var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
var AngularHttpFactory = (function () {
    function AngularHttpFactory() {
    }
    AngularHttpFactory.prototype.create = function (backend, requestOptions) {
        return new Http(backend, requestOptions);
    };
    return AngularHttpFactory;
}());
AngularHttpFactory = __decorate([
    Injectable()
], AngularHttpFactory);
export { AngularHttpFactory };
//# sourceMappingURL=AngularHttpFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/AngularHttpFactory.js
// module id = 529
// module chunks = 3